import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import * as moment from 'moment-timezone';
import { timeZone } from 'src/app/utils/utils.common';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-standingorder-detail-modal',
  templateUrl: './standingorder-detail-modal.component.html',
  styleUrls: ['./standingorder-detail-modal.component.css']
})
export class StandingorderDetailModalComponent implements OnInit {
  @Output() closeModal = new EventEmitter<any>
  @Input() trip: any;
  currentPage: number = 1;
  search: any;
  members: any;
  membersAppointment: any
  preMember: any;
  levelofservices: any
  standingorderList: any = [];
  PrelevelofService: any;
  preMembersAppointment: any
  spaceTypes: any
  preSpaceType: any
  companies: any
  preCompanies: any
  trips: any;
  showLabel: boolean = true;
  todayDate: any = [];
  user: any;
  timeZone: any = timeZone;
  preAppointmentTypes: any 
  preLevelOfServiceList: any 
  preSpaceTypeList: any ;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  statuses = [
    { value: 'all', label: 'All' },
    { value: 'pending', label: 'Pending' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'offered', label: 'Offered' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'onway', label: 'On Way' },
    { value: 'arrived', label: 'Arrived' },
    { value: 'in_progress', label: 'In Progress' },
  ];

  selectedStatus: any = 'pending';

  constructor(
    private sharedDataService: SharedDataService,
    private tripService: TripService,
    private appointmentType: AppointmentTypeService,
    private levelOfService: LosService,
    private spaceType: SpaceTypeService,
    private companyService: CompanyService,
  ) { }
  ngOnInit() {
    this.getUser();
    this.opendetailModal();
    this.getLevelOfService();
    this.getAppointmentTypes();
    this.getSpaceTypes();
    // this.getAllCompanies();
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user.timeZone) {
          this.timeZone = this.user.timeZone;
        }
        this.todayDate = [
          moment().tz(this.timeZone).startOf("day"),
          moment().tz(this.timeZone).add(7, "days").endOf("day").toDate()
        ];
      }
    })
  }

  opendetailModal() {
    this.tripService.getStandingorderById(this.trip.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.standingorderList = data
        this.setDefaultDateRange(data);
        this.getStandingOrderTrips(this.currentPage);
      }
    })
  }

  setDefaultDateRange(standingOrder: any) {
    const orderEnd = moment(standingOrder.endDate).tz(this.timeZone).endOf("day");
    const isExpired = moment().tz(this.timeZone).isAfter(orderEnd);
    if (isExpired) {
      this.todayDate = [
        orderEnd.clone().subtract(6, "days").startOf("day"),
        orderEnd.toDate()
      ];
    }
  }

  getStandingOrderTrips(page: any) {
    let queryparams = {
      limit: 50,
      page,
      status: this.selectedStatus,
      standingorder: this.trip.id,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      sortBy: 'pickup.time:asc',
    }
    if (this.selectedStatus === 'all') {
      queryparams.status = [
        'pending',
        'scheduled',
        'offered',
        'onway',
        'arrived',
        'in_progress',
        'completed',
        'cancelled',
      ];
    } else {
      queryparams.status = this.selectedStatus;
    }

    this.tripService.getAllTrips(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        // this.trips = data.results
          this.trips = data.results;
        // this.showLabel = queryparams.status !== 'scheduled';
        this.showLabel = !['scheduled', 'marketplace'].includes(queryparams.status)
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    })
  }

   getAppointmentTypes() {
    this.appointmentType.getPicker({ isActive: true, limit: 999 }).subscribe((data: any) => {
      if (data && data.results) {
        this.preMembersAppointment = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});

      }
    })
  }

  getLevelOfService() {
    this.levelOfService.getPicker({ isActive: true, limit: 999 }).subscribe((data: any) => {
      if (data && data.results) {
        this.preLevelOfServiceList = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getSpaceTypes() {
    this.spaceType.getPicker({ isActive: true, limit: 999 }).subscribe((data: any) => {
      if (data && data.results) {
        this.preSpaceType = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }
  getAllCompanies() {
    this.companyService.getCompanies()
    .pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results && data.results.length) {
        this.companies = data.results;
        this.preCompanies = this.companies.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

    onCloseModal() {
    this.closeModal.emit();
  }

  selectStatus() {
    this.getStandingOrderTrips(this.currentPage = 1);
  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
    this.getStandingOrderTrips(this.currentPage);
  }

   onPageChange(page: number) {
    this.currentPage = page;
    this.getStandingOrderTrips(this.currentPage);
  }
}


